// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._404 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
._404-img {
  width: 80rem;
  max-width: 80vw;
}
._404-text {
  margin-top: 60px;
  font-size: 22px;
  color: #112339;
}
`, "",{"version":3,"sources":["webpack://./src/pages/404/style.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AACJ;AAAI;EACI,YAAA;EACA,eAAA;AAER;AAAI;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAER","sourcesContent":["._404 {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    &-img {\n        width: 80rem;\n        max-width: 80vw;\n    }\n    &-text {\n        margin-top: 60px;\n        font-size: 22px;\n        color: #112339\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
